import "../search/search.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import { post } from "../../js/http";
import { getUrlParams, setMediaLen } from "../../js/util";

//服务类型 性别 最小年龄 最大年龄 最低资费 最高资费 省份ID 地区ID
$(document).ready(function() {
  let op = $(".valueList li");
  switch (getUrlParams("type")) {
    case "1":
      $($(".filter-type li")[0])
        .addClass("active")
        .siblings()
        .removeClass("active");
      document.title = "咨询服务_情感专家星座心理达人在线语音咨询_考米网";
      break;
    case "2":
      $($(".filter-type li")[1])
        .addClass("active")
        .siblings()
        .removeClass("active");
      document.title = "认证专家_认证心理情感咨询师在线语音咨询服务_考米网";
      break;
    case "3":
      $($(".filter-type li")[2])
        .addClass("active")
        .siblings()
        .removeClass("active");
      document.title = "社工志愿者_考米社工志愿者免费语音咨询交友_考米网";
      break;
    case "4":
      $($(".filter-type li")[3])
        .addClass("active")
        .siblings()
        .removeClass("active");
      document.title = "语音交友_美女帅哥在线语音电话聊天同城交友_考米网";
      break;
    default:
      $($(".filter-type li")[0])
        .addClass("active")
        .siblings()
        .removeClass("active");
      document.title = "咨询服务_情感专家星座心理达人在线语音咨询_考米网";
      break;
  }

  // 点击筛选条件
  for (let i = 0; i < op.length; i++) {
    op[i].onclick = function() {
      if ($(this).text() == "咨询服务")
        document.title = "咨询服务_情感专家星座心理达人在线语音咨询_考米网";
      else if ($(this).text() == "认证专家")
        document.title = "认证专家_认证心理情感咨询师在线语音咨询服务_考米网";
      else if ($(this).text() == "社工志愿者")
        document.title = "社工志愿者_考米社工志愿者免费语音咨询交友_考米网";
      else if ($(this).text() == "语音交友") {
        document.title = "语音交友_美女帅哥在线语音电话聊天同城交友_考米网";
      }

      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      //更新咨询服务列表
      getUserCallService();
    };
  }

  //获取省份
  getProvince();
  let areaTab = $(".area-tab li");
  for (let i = 0; i < areaTab.length; i++) {
    areaTab[i].onclick = function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      $($(".area-cont div.area-cont-item")[i])
        .siblings()
        .hide();
      $($(".area-cont div.area-cont-item")[i]).show();
    };
  }
  getUserCallService();
});

document.onclick = function(e) {
  if (
    $(e.target)
      .parent()
      .attr("id") != "provinceValue" &&
    !$("#provinceCon").is($(e.target)) &&
    $("#provinceCon").has(e.target).length === 0
  ) {
    // 可以在这里关闭省份选择框
    $("#provinceValue").removeClass("active");
    $("#provinceCon").hide();
  }

  if (
    $(e.target)
      .parent()
      .attr("id") != "provinceCon" &&
    $(e.target)
      .parent()
      .attr("id") != "cityValue" &&
    !$("#cityCon").is($(e.target)) &&
    $("#cityCon").has(e.target).length === 0
  ) {
    //点击空白区域关闭地区选择框
    $("#cityValue").removeClass("active");
    $("#cityCon").hide();
  }
};

function getProvince() {
  post("/ApiHome/ApiAction?_ControlName=GetCountryProvinceByPc").then(res => {
    var provinceStr = "<a data-id='' data-name='不限'>不限</a>";
    if (res.Data.OnlyOneData && res.Data.OnlyOneData.length) {
      res.Data.OnlyOneData.map(item => {
        provinceStr +=
          "<a data-id='" +
          item.AutoID +
          "' data-name='" +
          item.ProvinceShortName +
          "'>" +
          item.ProvinceShortName +
          "</a>";
      });
      $("#provinceCon").html(provinceStr);
      $("#cityValue a").html("不限");
      for (let i = 0; i < $("#provinceCon a").length; i++) {
        $("#provinceCon a")[i].onclick = function() {
          $("#provinceValue").attr("data-id", $(this).data("id"));
          $("#provinceValue a").html(this.getAttribute("data-name"));

          $("#cityValue a").html("不限");
          $("#cityValue").attr("data-id", "");
          getUserCallService();
          getCity({
            ProvinceID: this.getAttribute("data-id")
          });
        };
      }
    }
  });
}

function getCity(data) {
  post("/ApiHome/ApiAction?_ControlName=GetCountryCityByPc", data).then(res => {
    var cityStr = "<a data-id='' data-name='不限'>不限</a>";
    if (res.Data.OnlyOneData) {
      if (res.Data.OnlyOneData.length) {
        res.Data.OnlyOneData.map(item => {
          cityStr +=
            "<a data-id='" +
            item.AutoID +
            "' data-name='" +
            item.CountryShortName +
            "'>" +
            item.CountryShortName +
            "</a>";
        });
        $("#cityCon").html(cityStr);
        //展示城市选择款
        $("#provinceValue").removeClass("active");
        $("#provinceCon").hide();
        $("#cityValue").addClass("active");
        $("#cityCon").show();
        for (let i = 0; i < $("#cityCon a").length; i++) {
          $("#cityCon a")[i].onclick = function() {
            $("#cityValue").attr("data-id", $(this).data("id"));
            $("#cityValue a").html(this.getAttribute("data-name"));
            $("#cityCon").hide();
            getUserCallService();
          };
        }
      } else {
        $("#provinceCon").hide();
      }
    }
  });
}

function getUserCallService() {
  let ageRangeMin = -1,
    ageRangeMax = -1,
    feeRangeMin = -1,
    feeRangeMax = -1;
  switch (
    $(".filter-age .valueList")
      .find("li.active")
      .data("id")
  ) {
    case 0:
      (ageRangeMin = -1), (ageRangeMax = -1);
      break;
    case 1:
      (ageRangeMin = 18), (ageRangeMax = 25);
      break;
    case 2:
      (ageRangeMin = 26), (ageRangeMax = 35);
      break;
    case 3:
      (ageRangeMin = 36), (ageRangeMax = 50);
      break;
  }
  switch (
    $(".filter-fee .valueList")
      .find("li.active")
      .data("id")
  ) {
    case 0:
      (feeRangeMin = -1), (feeRangeMax = -1);
      break;
    case 1:
      (feeRangeMin = 0), (feeRangeMax = 0);
      break;
    case 2:
      (feeRangeMin = 0), (feeRangeMax = 2);
      break;
    case 3:
      (feeRangeMin = 2), (feeRangeMax = 5);
      break;
    case 4:
      (feeRangeMin = 5), (feeRangeMax = -1);
      break;
  }
  // 要先清空否则更换筛选条件后累加dom
  $("#km-search-content").html("");
  layui.use("flow", function() {
    var $ = layui.jquery; //不用额外加载jQuery，flow模块本身是有依赖jQuery的，直接用即可。
    var flow = layui.flow;
    flow.load({
      elem: "#km-search-content", //指定列表容器
      isAuto: true,
      mb: 50,
      isLazyimg: true,
      done: function(page, next) {
        //到达临界点（默认滚动触发），触发下一页
        post("/ApiHome/ApiAction?_ControlName=GetUserCallService", {
          PageIndex: page,
          Position: $(".filter-type li.active").attr("data-id"),
          PositionType: $(".km-search-type li.active").attr("data-id"),
          Sex: $(".filter-sex li.active").attr("data-id"),
          MinAge: ageRangeMin,
          MaxAge: ageRangeMax,
          MinFeeAmount: feeRangeMin,
          MaxFeeAmount: feeRangeMax,
          AtProvinces: $("#provinceValue").attr("data-id"),
          AtCities: $("#cityValue").attr("data-id")
        }).then(res => {
          if (res.ReturnStatus && res.Data.PositionType) {
            // $($("#km-search-filter li")[0]).attr(
            //   "data-id",
            //   res.Data.PositionType["推荐"]
            // );
            // $($("#km-search-filter li")[1]).attr(
            //   "data-id",
            //   res.Data.PositionType["最新"]
            // );
            // $($("#km-search-filter li")[2]).attr(
            //   "data-id",
            //   res.Data.PositionType["猜你喜欢"]
            // );
            let str = "";
            for (let i in res.Data.PositionType) {
              if (
                $(".km-search-type li.active").attr("data-id") ==
                res.Data.PositionType[i]
              ) {
                str +=
                  "<li data-id=" +
                  res.Data.PositionType[i] +
                  " class='active'>" +
                  i +
                  "</li>";
              } else {
                str +=
                  "<li data-id=" + res.Data.PositionType[i] + ">" + i + "</li>";
              }
            }
            switch ($(".filter-type li.active").index()) {
              case 0:
                $("#km-search-title").html(
                  "<h1 class='consulting'>咨询服务</h1><ul class='km-search-type' id='km-search-filter'>" +
                    str +
                    "</ul>"
                );
                break;
              case 1:
                $("#km-search-title").html(
                  "<h1 class='expert'>认证专家</h1><ul class='km-search-type' id='km-search-filter'>" +
                    str +
                    "</ul>"
                );
                break;
              case 2:
                $("#km-search-title").html(
                  "<h1 class='volunteer'>社工志愿者</h1><ul class='km-search-type' id='km-search-filter'>" +
                    str +
                    "</ul>"
                );
                break;
              case 3:
                $("#km-search-title").html(
                  "<h1 class='voice'>语音交友</h1><ul class='km-search-type' id='km-search-filter'>" +
                    str +
                    "</ul>"
                );
                break;
              default:
                $("#km-search-title").html(
                  "<h1 class='consulting'>咨询服务</h1><ul class='km-search-type' id='km-search-filter'>" +
                    str +
                    "</ul>"
                );
                break;
            }
          }
          for (let i = 0; i < $("#km-search-filter li").length; i++) {
            $("#km-search-filter li")[i].onclick = function() {
              $(this)
                .addClass("active")
                .siblings()
                .removeClass("active");
              getUserCallService();
            };
          }
          if (res.Data.OnlyOneData) {
            res.Data.OnlyOneData.forEach(item => {
              if (item.MediaLength) {
                item.transMediaLength = setMediaLen(item.MediaLength);
              }
            });
            let advisoryTemplate = require("./filter_service_advisory.art");
            var advisoryHtml = advisoryTemplate(res.Data);
            //执行下一页渲染，第二参数为：满足“加载更多”的条件，即后面仍有分页
            //pages为Ajax返回的总页数，只有当前页小于总页数的情况下，才会继续出现加载更多
            next(advisoryHtml, page < res.Data.TotalPageCount);
          }
        });
      }
    });
  });
}

let audioSetInterval;
window.playVoice = function(el) {
  window.clearInterval(audioSetInterval);
  SetTimeL();
  let vblist = $(".voice-box");
  if (el.getAttribute("data-media") == $("#audioPlayer").attr("src")) {
    //同一个音频
    if ($(el).hasClass("pause")) {
      $(el)
        .removeClass("pause")
        .addClass("playing");
      $("#audioPlayer")[0].play();
      audioSetInterval = setInterval(Func, 1000);
    } else {
      $(el)
        .removeClass("playing")
        .addClass("pause");
      $("#audioPlayer")[0].pause();
    }
  } else {
    $(el)
      .removeClass("pause")
      .addClass("playing");
    $("#audioPlayer").attr("src", el.getAttribute("data-media"));
    $("#audioPlayer")[0].play();
    audioSetInterval = setInterval(Func, 1000);
  }
  if (vblist.length) {
    for (var i = 0; i < vblist.length; i++) {
      if (
        vblist[i].getAttribute("data-media") != $("#audioPlayer").attr("src")
      ) {
        $(vblist[i])
          .removeClass("playing")
          .addClass("pause");
      }
    }
  }

  function Func() {
    // 创建倒计时
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        if ($(vblist[i]).hasClass("playing")) {
          // 设置剩余时长
          let temp = Number(
            $(vblist[i])
              .find("label.timeL")
              .attr("data-ctime")
          );
          if (temp - 1 >= 0) {
            $(vblist[i])
              .find("label.timeL")
              .attr("data-ctime", temp - 1);
            $(vblist[i])
              .find("label.timeL")
              .text(setMediaLen(temp - 1));
          }
        }
      }
    }
  }

  function SetTimeL() {
    let vblist = $(".voice-box");
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        $(vblist[i])
          .find("label.timeL")
          .text(setMediaLen(vblist[i].getAttribute("data-time")));
      }
    }
  }
  var audio = document.getElementById("audioPlayer");
  if (audio) {
    audio.loop = false;
    audio.addEventListener(
      "ended",
      function() {
        console.log("结束");
        SetTimeL();
        //清除倒计时
        window.clearInterval(audioSetInterval);
        let vblist = $(".voice-box");
        if (vblist.length) {
          for (var i = 0; i < vblist.length; i++) {
            if (
              vblist[i].getAttribute("data-media") ==
              $("#audioPlayer").attr("src")
            ) {
              $(vblist[i])
                .removeClass("playing")
                .addClass("pause");
            }
          }
        }
        //在这个方法里写相应的逻辑就可以了
      },
      false
    );
  }
};
